import React, { useState } from "react";

export default function SelectFilter({ name, value, options, setFilter, getItem, forceUpdateReport }) {
    const [blocked, setBlocked] = useState(false);

    const onChange = (e) => {
        if (blocked) {
            return;
        }
        setBlocked(true);
        setFilter({ name, value: e.target.value });
        setTimeout(() => {
            getItem().then(() => {
                setBlocked(false);
                forceUpdateReport();
            });
        }, 0);
    };

    return (
        <div className="mb-md-0 report__filters--mr">
            <select className="form-control form-control-sm" onChange={onChange} value={value}>
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
